import { FaArrowLeft, FaQuestionCircle, FaUserCircle, FaBook, FaSignOutAlt, FaCommentDots, FaVolumeUp, FaVolumeMute } from 'react-icons/fa';

const Header = ({ 
  title = "ZenoKids",
  subtitle = null,
  showBackButton = false,
  onBack = null,
  showHelpButton = true,
  onHelp = null,
  showFeedbackButton = true,
  onFeedback = null,
  showProfileButton = true,
  onProfile = null,
  showLogoutButton = true,
  onLogout = null,
  audioEnabled = true,
  onAudioToggle = null,
  leftContent = null,
  className = ""
}) => {
  return (
    <div className={`bg-white/80 backdrop-blur-sm shadow-lg border-b border-white/20 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Left Section */}
          <div className="flex items-center space-x-4">
            {/* Back Button */}
            {showBackButton && onBack && (
              <button 
                onClick={onBack} 
                className="flex items-center space-x-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors shadow-sm"
                aria-label="Go back"
              >
                <FaArrowLeft className="text-sm" />
                <span className="hidden sm:inline">Back</span>
              </button>
            )}

            {/* Custom Left Content or Default Logo/Title */}
            {leftContent || (
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                  <FaBook className="text-white text-xl" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                    {title}
                  </h1>
                  {subtitle && (
                    <div className="text-sm text-gray-600">
                      {subtitle}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-3">
            {/* Help Button */}
            {showHelpButton && onHelp && (
              <button 
                onClick={onHelp} 
                className="flex items-center space-x-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors shadow-sm"
                aria-label="Help"
              >
                <FaQuestionCircle className="text-lg" />
                <span className="hidden sm:inline">Help</span>
              </button>
            )}

            {/* Feedback Button */}
            {showFeedbackButton && onFeedback && (
              <button
                onClick={onFeedback}
                className="flex items-center space-x-2 px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors shadow-sm"
                aria-label="Feedback"
              >
                <FaCommentDots className="text-lg" />
                <span className="hidden sm:inline">Feedback</span>
              </button>
            )}

            {/* Audio Toggle Button */}
            {onAudioToggle && (
              <button
                onClick={onAudioToggle}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors shadow-sm ${
                  audioEnabled 
                    ? 'bg-indigo-500 text-white hover:bg-indigo-600' 
                    : 'bg-gray-200 text-gray-500 hover:bg-gray-300'
                }`}
                aria-label={audioEnabled ? "Disable Audio" : "Enable Audio"}
              >
                {audioEnabled ? <FaVolumeUp className="text-lg" /> : <FaVolumeMute className="text-lg" />}
                <span className="hidden sm:inline">{audioEnabled ? 'Audio On' : 'Audio Off'}</span>
              </button>
            )}

            {/* Profile Button */}
            {showProfileButton && onProfile && (
              <button 
                onClick={onProfile} 
                className="flex items-center space-x-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors shadow-sm"
                aria-label="Profile"
              >
                <FaUserCircle className="text-lg" />
                <span className="hidden sm:inline">Profile</span>
              </button>
            )}

            {/* Logout Button */}
            {showLogoutButton && onLogout && (
              <button 
                onClick={onLogout} 
                className="flex items-center space-x-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors shadow-sm"
                aria-label="Logout"
              >
                <FaSignOutAlt className="text-sm" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
